import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/uns/")({
  staticData: {
    title: "titles.uns",
  },
  loader: () => redirect({ to: "/uns/home" }),
});
